const es = {
    actionAlready: "¿Aún no estás registrado? Inicia sesión",
    actionExit: "Cerrar sesión",
    actionLogin: "INICIAR SESIÓN",
    actionRegister: "REGISTRARSE",
    actionSave: "GUARDAR",
    actionStart: "INICIAR",
    actionContinue: "CONTINUAR",
    actionReset: "REINICIAR EVALUACIÓN",
    actionDoDiagnost: "MOSTRAR DIAGNÓSTICO",
    actionYes: "Sí",
    actionNo: "No",
    actionNext: "SIGUIENTE",
    actionBusinessCase: "MOSTRAR BUENA PRÁCTICA DE LA EMPRESA",
    actionBusinessCases: "MOSTRAR BUENAS PRÁCTICAS DE LAS EMPRESAS",
    actionOpenUrl: "ABRIR URL",
    actionFilter: "FILTRAR",

    /** HOME */
    msgHomeTitleOne: "Mide y aumenta el nivel de madurez circular de tu empresa de muebles",
    msgHomeSubTitle: "La herramienta en línea FurnCIRCLE evalúa el progreso de tu empresa hacia la madurez circular en función de las estrategias de diseño circular implementadas",

    msgHomeSection2: "Evalúa y mejora la madurez de economía circular de tu empresa de mobiliario",
    msgHomeSection2Text: "<span style='font-weight:bold;'>Herramienta de Evaluación de Economía Circular FurnCIRCLE</span><br/><br/>FurnCIRCLE es una herramienta online de autoevaluación que ayuda a los fabricantes de mobiliario a evaluar su nivel de madurez en economía circular e identificar oportunidades de mejora.<br/><br/><span style='font-weight:bold;'>¿Estás preparado para evaluar tu madurez circular?</span><ul style='padding-left: 20px'><li>Responde preguntas sobre las estrategias de diseño circular implementadas en tu empresa.</li><li>Descubre tu nivel de madurez en economía circular.</li><li>Identifica estrategias y buenas prácticas para ayudar a tu empresa a pasar al siguiente nivel.</li><li>Aprende de ejemplos reales del sector y sigue mejorando tu desempeño circular.</li></ul>",
    msgHomeSection21Text: "<span style='font-weight:bold;'>Contribuye a la Evaluación Europea de Circularidad del Mobiliario | Proyecto R-evolve</span><br/><br/>FurnCIRCLE se utiliza actualmente en el <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>proyecto R-evolve</a> para evaluar la madurez de economía circular del sector europeo del mobiliario. <span style='font-weight:bold;'>Más de 400 empresas de toda Europa</span> están invitadas a participar y ayudar a mapear el nivel actual de circularidad de la industria.<br/><br/>Participa en la evaluación, evalúa tu empresa y contribuye a dar forma al futuro del sector.<br/><br/>Todos los datos se tratan de forma confidencial y se utilizan únicamente de manera agregada para fines de benchmarking e investigación. <span style='font-weight:bold;'>Los participantes recibirán acceso a resultados agregados de benchmarking</span>, lo que les permitirá comparar su desempeño con promedios sectoriales basados en datos anonimizados y agregados de empresas participantes del sector europeo del mobiliario.<br/><br/>La evaluación tarda aproximadamente entre 30 y 45 minutos en completarse.",
    msgHomeSection3: "Socios",
    msgHomeSection2Btn: "Comienza tu evaluación",
    msgHomeSection3Btn: "CONTACTO",

    /** HEADER */
    msgHeader1: "Estrategias de diseño circular y buenas prácticas",
    msgHeader4: "Iniciar sesión",

    /** DRAWER */
    msgCompany: "EMPRESA",
    msgDrawer1: "1. Responder",
    msgDrawer2: "2. Evaluar",
    msgDrawer3: "3. Mejorar",
    msgDrawer4: "Colección de estrategias",
    msgDrawer6: "Configuración",
    msgDrawer7: "Cerrar sesión",

    /** LOGIN */
    msgWelcome: "Bienvenido",
    msgWelcomeSubtitle: "Por favor, inicia sesión para continuar",

    /** REGISTER */
    msgGetStarted: "Comenzar",
    msgGetStartedSubtitle: "Esta herramienta de autoevaluación es gratuita y confidencial",

    msgFirstname: "Nombre",
    msgLastname: "Apellido",
    msgEmail: "Correo electrónico",
    msgPassword: "Contraseña",
    msgConfirmPassword: "Confirmar contraseña",
    msgCompanyUser: "Empresa o nombre de usuario",

    msgLegalRegister: "He leído y acepto la <a href='https://ambitcluster.org/en/privacy-policy'>Política de Privacidad.</a>",
    errorLegalRegister: "Debes leer y aceptar la Política de Privacidad antes de continuar",
    msgLegalRegisterText: "Nota: AMBIT recopila datos personales a través de la herramienta FurnCIRCLE únicamente con fines técnicos y operativos. Las respuestas a la encuesta serán analizadas en el marco del proyecto R-evolve. Ningún dato personal ni información que identifique a la empresa será compartida con los socios del consorcio R-evolve. Todas las respuestas serán analizadas de forma estrictamente anónima. Con fines estadísticos, los datos podrán agregarse por país o sector de actividad. En ningún caso los resultados generados por la herramienta se vincularán ni se utilizarán para identificar a ninguna empresa en particular.",

    msgNotRegister: "¿Aún no estás registrado? <b>Crea una cuenta aquí</b>",
    msgAlreadyRegister: "¿Ya estás registrado? <b>Inicia sesión aquí</b>",

    /** HOME TOOL */
    msgClickImage: "Haz clic para ampliar el sistema de modelo lineal versus circular.",

    msgArea: "ÁREA",
    msgProgress: "PREGUNTAS RESPONDIDAS",

    msgAssessmentAreas: "Estrategias de Diseño Circular y Ciclo de Vida del Producto",
    msgAssessmentDesc: "Las estrategias de diseño circular se aplican principalmente durante la fase de diseño y desarrollo de los productos. Sin embargo, su impacto (positivo) tiene lugar en una o varias fases posteriores del ciclo de vida del producto, respaldado por los servicios posventa. Por ello, una forma de clasificar las estrategias de diseño circular es según la etapa del ciclo de vida sobre la que impactan: diseño, recursos materiales, producción, distribución, fase de uso y fin de vida.<br/><br/>Para integrar estrategias de circularidad, el enfoque general de una empresa hacia la futura Economía Circular es clave en los 'aspectos del producto' establecidos en el Art. 5(1) del Reglamento Europeo de Ecodiseño para Productos Sostenibles (ESPR) y en el Pasaporte Digital de Producto (DPP) introducido por el ESPR.<br/><br/>El ESPR es uno de los pilares de la estrategia de la UE para impulsar una Economía Circular (EC) eficiente en recursos, baja en toxicidad y respetuosa con el clima. Establece un marco de condiciones vinculantes de acceso al mercado para los productos, exigiendo que cumplan objetivos ambiciosos de desempeño ambiental y eficiencia de recursos para mantenerse dentro de los límites planetarios. Según los 'aspectos del producto' definidos en el Art. 5(1), los productos deben diseñarse para un uso prolongado, reparación sencilla, reutilización y reacondicionamiento, así como para un reciclaje seguro (también conocido como estrategias R). También deben estar libres de sustancias problemáticas y ser adecuados para una recuperación de materiales de alta calidad.<br/><br/>El DPP, tal como lo introduce el ESPR, está concebido para proporcionar la infraestructura armonizada correspondiente de datos de producto que impulse la transparencia, la trazabilidad y la innovación empresarial sostenible.<br/><br/>Para más detalles, consulte la ficha R-evolve | <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>https://r-evolve.eu/</a><br/><br/><span style='font-weight:bold;'>Por favor, responda todas las preguntas de cada bloque o fase del ciclo de vida, determine su nivel de madurez circular y planifique su mejora y transición hacia una Economía Circular más avanzada.</span>",

    msgAssessment: "Evaluación FurnCIRCLE",
    msgNotApply: "Marca todas las respuestas que correspondan al desempeño circular actual de tu empresa. Las respuestas se guardan automáticamente.",
    msgMarkImportant: "Marcar como importante",
    msgComment: "Comentario",
    msgCommentHolder: "Puedes escribir aquí cualquier información relacionada o tus propios comentarios.",

    /** ANSWER */
    msgPerformance: "Informe de Evaluación",
    msgPerformanceSubtitle: "Consulta el índice de madurez circular de tu empresa y de cada fase del ciclo de vida de tus productos.",
    msgCompanyLevel: "Índice de madurez circular de tu empresa (0%-100%)",
    msgBlockArea: "FASE DEL CICLO DE VIDA",
    msgBlockValues: "VALORES",

    /** ASSESS */
    msgImprovement: "Informe de Mejora",
    msgImprovementMainSubtitle: "Aprende qué puedes hacer para mejorar continuamente la circularidad de tu empresa. Conoce estrategias de diseño y buenas prácticas de empresas para llevar tu empresa al siguiente nivel.</br></br>Las fases del ciclo de vida y estrategias de diseño circular con una etiqueta/círculo “rojo” tienen un nivel de desempeño igual o inferior al 25% de su valor máximo y, por lo tanto, pueden considerarse una prioridad principal para mejorar la circularidad de la empresa. Las fases o estrategias con una etiqueta/círculo “naranja” tienen un nivel de desempeño superior al 25% y menor o igual al 75%, por lo que también es importante abordar su mejora. Las fases o estrategias con una etiqueta/círculo “verde” tienen un nivel de desempeño superior al 75% y, por lo tanto, son menos prioritarias para la mejora.",
    msgImprovementSubtitle: "Aprende qué puedes hacer para mejorar continuamente la circularidad de tu empresa. Conoce estrategias de diseño y buenas prácticas de empresas para llevar tu empresa al siguiente nivel.",
    msgLifecyclePhases: "Fases del ciclo de vida",
    msgLifecycleIndex: "Índice de circularidad de la fase",
    msgActionsToImplement: "Acciones a implementar:",
    msgBaselineScore: "Mi puntuación base",
    msgBusinessCaseEmpty: "¡Felicidades! Ya has implementado las principales estrategias incluidas en esta categoría",

    msgCat1: "ECONÓMICO Y ORGANIZACIONAL",
    msgCat2: "SOCIAL",
    msgCat3: "AMBIENTAL",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Explora y descubre la colección completa de estrategias de diseño circular y buenas prácticas de empresas del proyecto FurnCIRCLE.",
    msgLifecyclePhase: "Fase del ciclo de vida",
    msgDifficulty: "Dificultad de implementación",
    msgBusinessDynamics: "Generación o entrega de valor",
    msgBusinessFactors: "Propuesta de valor / Costos / Beneficios",

    /** SETTINGS */
    msgUserInfo: "Información del usuario",
    msgUserCredentials: "Credenciales del usuario",

    /** MODAL */
    msgAreSure: "¿Estás seguro?",

    msgSuccess: "Datos actualizados con éxito",
    msgDeleteSuccess: "Datos eliminados con éxito",

    /** ALT TEXT */
    msgSaveCommentAlt: "Guarda el “Comentario”. No es necesario guardar las respuestas a las preguntas; se guardan automáticamente.",
    msgDifficultyAlt: "Esta etiqueta indica la dificultad de implementar la estrategia de diseño circular.",
    msgBusinessBlockAlt: "Esta etiqueta indica qué bloque de negocio del modelo CANVAS (Generación de Valor o Entrega de Valor) se ve afectado por la implementación de la estrategia de diseño circular.",
    msgImpactBlockAlt: "Esta etiqueta indica qué bloque de impacto del modelo CANVAS (Costos, Beneficios o Propuesta de Valor) se ve afectado por la implementación de la estrategia de diseño circular.",

    /** ERROR */
    errorOblData: "Rellena todos los campos obligatorios",
    errorEmailFormat: "Error en el formato del correo electrónico",
    errorUserIncorrect: "Correo/contraseña incorrectos",
    errorSend: "Error de comunicación, por favor espera e inténtalo de nuevo más tarde",
    errorLength: "Se ha excedido el número de caracteres",
    errorPassSame: "Las contraseñas no coinciden",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Recuperación de contraseña",
    msgRecoveryPasswordSubtitle: "Por favor, introduce tu dirección de correo electrónico para recibir un código de restablecimiento de contraseña.",
    msgCode: "Código",
    msgNewPassword: "Nueva contraseña",
    actionRequestCode: "SOLICITAR CÓDIGO",
    actionUpdate: "ACTUALIZAR",
    actionBack: "VOLVER",
    msgForgetPassword: "¿Olvidaste tu contraseña?",
    errorRecovery: "Error en la recuperación de contraseña, por favor verifica el código proporcionado",

    /** FOOTER */
    msgFooterContact: "CONTACTO",

    msgFooterGr: "Financiado por la Unión Europea. Las opiniones expresadas son únicamente las del autor(es) y no reflejan necesariamente las de la Unión Europea. Ni la Unión Europea ni la autoridad otorgante pueden ser responsables de ellas. Convocatoria y referencia del acuerdo de subvención: SOCPL-2022-SOC-DIALOG-01 (Proyecto 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Todos los derechos reservados",

    msgFooterLegal: "Aviso legal",
    msgFooterPrivacy: "Privacidad",
    msgFooterCookies: "Política de cookies",

    /** PROGRESS VALUES */
    msgProgress0: "Estrategias de diseño circular",

    /** COMPANY SIZES */
    msgCompanySize: "Tamaño de la empresa",
    msgCompanySize1: "Menos de 10 empleados",
    msgCompanySize2: "10-30 empleados",
    msgCompanySize3: "30-50 empleados",
    msgCompanySize4: "Más de 50 empleados",

    /** PRODUCT TYPES */
    msgProductType: "Tipo de productos que fabricas",
    msgProductType1: "Muebles de dormitorio y camas",
    msgProductType2: "Dormitorios infantiles / juveniles",
    msgProductType3: "Sistemas de descanso: colchones y bases",
    msgProductType4: "Muebles para zona de estar",
    msgProductType5: "Sillas",
    msgProductType6: "Cocinas",
    msgProductType7: "Muebles tapizados",
    msgProductType8: "Muebles de exterior",
    msgProductType9: "Muebles en kit / DIY",
    msgProductType10: "Mobiliario para centros sanitarios y asistenciales (hospitales, residencias, etc.)",
    msgProductType11: "Mobiliario para espacios públicos (aeropuertos, iglesias, teatros y cines) excluyendo asientos",
    msgProductType12: "Mobiliario residencial a medida",
    msgProductType13: "Accesorios - Elementos complementarios",
    msgProductType14: "Accesorios - Objetos decorativos",
    msgProductType15: "Accesorios - Textiles",
    msgProductType16: "Equipamiento comercial (retail / interiores contract)",
    msgProductType17: "Componentes semielaborados para muebles",
    msgProductType18: "Otros muebles",
    msgProductType19: "Muebles de baño (incluyendo encimeras)",
    msgProductType20: "Muebles de oficina",
    msgProductType21: "Mamparas / tabiques de oficina",
    msgProductType22: "Asientos de oficina",
    msgProductType23: "Asientos públicos / asientos para espacios colectivos",
    msgProductType24: "Paneles acústicos / mobiliario acústico",
    msgProductType25: "Componentes de mobiliario de oficina",
    msgProductType26: "Otros muebles/equipos de oficina",
    msgProductType27: "Mobiliario educativo",

    /* COUNTRIES */
    msgCountry: "País",
    msgAfghanistan: "Afganistán",
    msgAlbania: "Albania",
    msgAlgeria: "Argelia",
    msgAmericanSamoa: "Samoa Americana",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguila",
    msgAntarctica: "Antártida",
    msgAntiguaandBarbuda: "Antigua y Barbuda",
    msgArgentina: "Argentina",
    msgArmenia: "Armenia",
    msgAruba: "Aruba",
    msgAustralia: "Australia",
    msgAustria: "Austria",
    msgAzerbaijan: "Azerbaiyán",
    msgBahamas: "Bahamas",
    msgBahrain: "Baréin",
    msgBangladesh: "Bangladés",
    msgBarbados: "Barbados",
    msgBelarus: "Bielorrusia",
    msgBelgium: "Bélgica",
    msgBelize: "Belice",
    msgBenin: "Benín",
    msgBermuda: "Bermudas",
    msgBhutan: "Bután",
    msgBolivia: "Bolivia",
    msgBosniaHerzegovina: "Bosnia y Herzegovina",
    msgBotswana: "Botsuana",
    msgBouvetIsland: "Isla Bouvet",
    msgBrazil: "Brasil",
    msgBritishIndian: "Territorio Británico del Océano Índico",
    msgBrunei: "Brunéi",
    msgBulgaria: "Bulgaria",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Camboya",
    msgCameroon: "Camerún",
    msgCanada: "Canadá",
    msgCapeVerde: "Cabo Verde",
    msgCaymanIslands: "Islas Caimán",
    msgCentralAfrican: "República Centroafricana",
    msgChad: "Chad",
    msgChile: "Chile",
    msgChina: "China",
    msgChristmasIsland: "Isla de Navidad",
    msgCocosIslands: "Islas Cocos (Keeling)",
    msgColombia: "Colombia",
    msgComoros: "Comoras",
    msgCongo: "Congo",
    msgRepublicCongo: "República Democrática del Congo",
    msgCookIslands: "Islas Cook",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Costa de Marfil",
    msgCroatia: "Croacia",
    msgCuba: "Cuba",
    msgCyprus: "Chipre",
    msgCzechRepublic: "República Checa",
    msgDenmark: "Dinamarca",
    msgDjibouti: "Yibuti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "República Dominicana",
    msgEastTimor: "Timor Oriental",
    msgEcuador: "Ecuador",
    msgEgypt: "Egipto",
    msgEngland: "Inglaterra",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Guinea Ecuatorial",
    msgEritrea: "Eritrea",
    msgEstonia: "Estonia",
    msgEthiopia: "Etiopía",
    msgFalklandIslands: "Islas Malvinas",
    msgFaroeIslands: "Islas Feroe",
    msgFijiIslands: "Islas Fiyi",
    msgFinland: "Finlandia",
    msgFrance: "Francia",
    msgFrenchGuiana: "Guayana Francesa",
    msgFrenchPolynesia: "Polinesia Francesa",
    msgFrenchSouthern: "Territorios Australes Franceses",
    msgGabon: "Gabón",
    msgGambia: "Gambia",
    msgGeorgia: "Georgia",
    msgGermany: "Alemania",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grecia",
    msgGreenland: "Groenlandia",
    msgGrenada: "Granada",
    msgGuadeloupe: "Guadalupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernesey",
    msgGuinea: "Guinea",
    msgGuineaBissau: "Guinea-Bisáu",
    msgGuyana: "Guyana",
    msgHaiti: "Haití",
    msgHeardMcDonald: "Islas Heard y McDonald",
    msgHolySee: "Santa Sede (Estado de la Ciudad del Vaticano)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Hungría",
    msgIceland: "Islandia",
    msgIndia: "India",
    msgIndonesia: "Indonesia",
    msgIran: "Irán",
    msgIraq: "Irak",
    msgIreland: "Irlanda",
    msgIsrael: "Israel",
    msgIsleMan: "Isla de Man",
    msgItaly: "Italia",
    msgJamaica: "Jamaica",
    msgJapan: "Japón",
    msgJersey: "Jersey",
    msgJordan: "Jordania",
    msgKazakhstan: "Kazajistán",
    msgKenya: "Kenia",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuwait",
    msgKyrgyzstan: "Kirguistán",
    msgLaos: "Laos",
    msgLatvia: "Letonia",
    msgLebanon: "Líbano",
    msgLesotho: "Lesoto",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Libia",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Lituania",
    msgLuxembourg: "Luxemburgo",
    msgMacao: "Macao",
    msgNorthMacedonia: "Macedonia del Norte",
    msgMadagascar: "Madagascar",
    msgMalawi: "Malaui",
    msgMalaysia: "Malasia",
    msgMaldives: "Maldivas",
    msgMali: "Malí",
    msgMalta: "Malta",
    msgMarshallIslands: "Islas Marshall",
    msgMartinique: "Martinica",
    msgMauritania: "Mauritania",
    msgMauritius: "Mauricio",
    msgMayotte: "Mayotte",
    msgMexico: "México",
    msgMicronesia: "Micronesia, Estados Federados de",
    msgMoldova: "Moldavia",
    msgMonaco: "Mónaco",
    msgMongolia: "Mongolia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegro",
    msgMorocco: "Marruecos",
    msgMozambique: "Mozambique",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Países Bajos",
    msgNetherlandsAntilles: "Antillas Neerlandesas",
    msgNewCaledonia: "Nueva Caledonia",
    msgNewZealand: "Nueva Zelanda",
    msgNicaragua: "Nicaragua",
    msgNiger: "Níger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Isla Norfolk",
    msgNorthKorea: "Corea del Norte",
    msgNorthernIreland: "Irlanda del Norte",
    msgNorthernMariana: "Islas Marianas del Norte",
    msgNorway: "Noruega",
    msgOman: "Omán",
    msgPakistan: "Pakistán",
    msgPalau: "Palaos",
    msgPalestine: "Palestina",
    msgPanama: "Panamá",
    msgPapua: "Papúa Nueva Guinea",
    msgParaguay: "Paraguay",
    msgPeru: "Perú",
    msgPhilippines: "Filipinas",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polonia",
    msgPortugal: "Portugal",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Catar",
    msgReunion: "Reunión",
    msgRomania: "Rumania",
    msgRussianFederation: "Federación Rusa",
    msgRwanda: "Ruanda",
    msgSaintHelena: "Santa Elena",
    msgSaintKitts: "San Cristóbal y Nieves",
    msgSaintLucia: "Santa Lucía",
    msgSaintPierre: "San Pedro y Miquelón",
    msgSaintVincent: "San Vicente y las Granadinas",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Santo Tomé y Príncipe",
    msgSaudiArabia: "Arabia Saudita",
    msgScotland: "Escocia",
    msgSenegal: "Senegal",
    msgSerbia: "Serbia",
    msgSeychelles: "Seychelles",
    msgSierraLeone: "Sierra Leona",
    msgSingapore: "Singapur",
    msgSlovakia: "Eslovaquia",
    msgSlovenia: "Eslovenia",
    msgSolomonIslands: "Islas Salomón",
    msgSomalia: "Somalia",
    msgSouthAfrica: "Sudáfrica",
    msgSouthSandwich: "Georgia del Sur y las Islas Sandwich del Sur",
    msgSouthKorea: "Corea del Sur",
    msgSouthSudan: "Sudán del Sur",
    msgSpain: "España",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Sudán",
    msgSuriname: "Surinam",
    msgSvalbardJan: "Svalbard y Jan Mayen",
    msgSwaziland: "Suazilandia",
    msgSweden: "Suecia",
    msgSwitzerland: "Suiza",
    msgSyria: "Siria",
    msgTajikistan: "Tayikistán",
    msgTanzania: "Tanzania",
    msgThailand: "Tailandia",
    msgTimorLeste: "Timor-Leste",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad y Tobago",
    msgTunisia: "Túnez",
    msgTurkey: "Turquía",
    msgTurkmenistan: "Turkmenistán",
    msgTurksCaicos: "Islas Turcas y Caicos",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ucrania",
    msgUnitedArabEmirates: "Emiratos Árabes Unidos",
    msgUnitedKingdom: "Reino Unido",
    msgUnitedStates: "Estados Unidos",
    msgUnitedStatesMinor: "Islas Menores de los Estados Unidos",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Uzbekistán",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Islas Vírgenes Británicas",
    msgVirginIslandsUS: "Islas Vírgenes de los EE. UU.",
    msgWales: "Gales",
    msgWallisFutuna: "Wallis y Futuna",
    msgWesternSahara: "Sáhara Occidental",
    msgYemen: "Yemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabue",
}

export default es;